import { render } from "./MMOfficeRequest.vue?vue&type=template&id=48ac11da"
import script from "./MMOfficeRequest.vue?vue&type=script&lang=js"
export * from "./MMOfficeRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__